const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20warm%20candlelight%2C%20elegant%20silk%20robes%2C%20ornate%20gold%20decorations%2C%20atmospheric%20period%20drama%20aesthetic%2C%20soft%20cinematic%20lighting%2C%20rich%20red%20and%20gold%20color%20palette%2C%20editorial%20photography%20style&width=600&height=400&seq=97cinema-carousel-1&orientation=landscape',
    title: '古装权谋大剧专区',
    desc: '朝堂风云、宫闱秘事，高分古装剧一网打尽。从《琅琊榜》到《庆余年》，经典与新品齐备，带你穿越古今。',
    tag: '热门专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20urban%20cityscape%20at%20night%20through%20rain%20speckled%20window%2C%20warm%20neon%20lights%20reflecting%2C%20romantic%20atmospheric%20mood%2C%20soft%20focus%2C%20Korean%20drama%20aesthetic%2C%20cinematic%20composition%2C%20deep%20blues%20and%20warm%20ambers&width=600&height=400&seq=97cinema-carousel-2&orientation=landscape',
    title: '韩剧精选合集',
    desc: '从虐恋到甜宠，从悬疑到治愈，全网最全韩剧资源。宋仲基、金秀贤、全智贤代表作一站收录。',
    tag: '韩流来袭',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20American%20urban%20landscape%20with%20warm%20sunset%20light%2C%20film%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20cinematic%20wide%20shot%2C%20sophisticated%20mood%2C%20golden%20hour%20photography%2C%20premium%20TV%20drama%20aesthetic&width=600&height=400&seq=97cinema-carousel-3&orientation=landscape',
    title: '美剧高分神作',
    desc: 'IMDb与豆瓣双高分认证，从《绝命毒师》到《权力的游戏》，口碑神剧全集在线观看，一季不落。',
    tag: '口碑精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20scene%20with%20soft%20blankets%20and%20ambient%20lighting%2C%20romantic%20atmosphere%2C%20gentle%20pink%20and%20cream%20tones%2C%20sweet%20dreamy%20mood%2C%20editorial%20lifestyle%20photography%2C%20intimate%20comforting%20vibe&width=600&height=400&seq=97cinema-carousel-4&orientation=landscape',
    title: '甜宠剧场专区',
    desc: '糖分超标警告！精选全网最甜爱情剧，古装甜宠、都市蜜恋一应俱全，治愈你的每一个夜晚。',
    tag: '甜蜜推荐',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20detective%20office%20with%20warm%20desk%20lamp%2C%20case%20files%20and%20evidence%20board%2C%20noir%20atmosphere%2C%20dramatic%20chiaroscuro%20lighting%2C%20suspenseful%20cinematic%20composition%2C%20deep%20shadows%20and%20golden%20highlights&width=600&height=400&seq=97cinema-carousel-5&orientation=landscape',
    title: '悬疑烧脑剧场',
    desc: '国产悬疑、韩式反转、美式探案三大流派齐聚，高能剧情让你停不下来。真探迷必入专区。',
    tag: '烧脑必看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20landscape%20with%20floating%20mountains%20and%20misty%20waterfalls%2C%20soft%20magical%20glow%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%20blended%20with%20cinematic%20lighting%2C%20dreamy%20celestial%20atmosphere%2C%20pearly%20and%20jade%20tones&width=600&height=400&seq=97cinema-carousel-6&orientation=landscape',
    title: '仙侠奇幻世界',
    desc: '御剑飞行、三界争锋，最新仙侠剧全集集结。从经典到新番，飞天遁地的奇幻世界等你探索。',
    tag: '奇幻之旅',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选六大追剧专题，快速找到你的下一部心头好
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group flex flex-col bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLImageElement).setAttribute('data-error', 'true'); }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-accent-500 text-foreground-950 text-xs font-semibold rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}